import AnimationClip from '../AnimationClip';
import TransformComponent from '../../../Component/Transform';
import Point from '../../../Utility/Point';
import Crop from '../../../Prototype/World/Crop';
import { GrowthStage, IHarvestSettings } from '../../../State/World/IFieldData';
import GameObject from '../../../GameObject/GameObject';
import { Random } from '../../../Utility/Random';
import FieldComponent from '../../../Component/Map/Field';
import Field from '../../../Prototype/World/Field';
import { StartAnimationClip } from '../AnimationHelper';
import CropComponent from '../../../Component/Map/Crop';
import { delay } from '../../../Utility/Task/TaskQueue';
import HarvestCrop from '../../../Prefabs/UI/Harvest/HarvestCrop';
import WorldHUDHandler from '../../UI/HUD/WorldHUDHandler';
import CoinBar, { hackForceCurrencyAnimation } from '../../../Prefabs/UI/HUD/CoinBar';
import { CropTransition } from 'System/Animation/Clip/CropTransition';
import { Counter } from 'System/Animation/Clip/Counter';

type FieldHarvestMeta = {
    unlockedCrops: Crop[];
    rewardTextures: Random.IWeightedItem<string>[];
    destination: Point;
    previousCoins: number;
    income: number;
}

export class FieldHarvest extends AnimationClip {
    public rewardContainer: GameObject;

    public* execute(field: Field, meta: FieldHarvestMeta): IterableIterator<number> {
        this.rewardContainer = GameObject.findFirstByName(WorldHUDHandler.CROP_CONTAINER);
        const fieldComponent = field.getComponent(FieldComponent,);

        meta.unlockedCrops.forEach((crop: Crop) => {
            const cropComponent = crop.getComponent(CropComponent);
            const origin = new Point();
            origin.copy(crop.getComponent(TransformComponent).position);

            const rewards: HarvestCrop[] = FieldHarvest.createRewards(
                origin,
                fieldComponent.harvestSettings,
                meta.rewardTextures,
            );
            cropComponent.rewardObjects = rewards;

            cropComponent.rewardObjects.forEach((reward: HarvestCrop) => {
                this.rewardContainer.addChild(reward);
                reward.play(meta.destination);
            });
        });

        meta.unlockedCrops.forEach((crop: Crop) => {
            const cropComponent: CropComponent = crop.getComponent(CropComponent);

            // Transition crops
            StartAnimationClip(
                new CropTransition(crop, {
                    amplitude: 0.25,
                    duration: 275,
                    stage: fieldComponent.currentStage,
                    delay: 3500,
                    transitionTexture: cropComponent.textures[GrowthStage.HARVESTED] ?
                        Random.getRandomWeighted(cropComponent.textures[GrowthStage.HARVESTED]) : undefined,
                }),
            );
        });

        yield* delay(2500);

        hackForceCurrencyAnimation();

        const coinText: GameObject = GameObject.findFirstByName(
            WorldHUDHandler.COIN_BAR_BTN_NAME,
        );

        StartAnimationClip(
            new Counter(coinText, {
                startValue: meta.previousCoins,
                finalValue: meta.previousCoins + meta.income,
                onUpdateOverride: function () {
                    (coinText as CoinBar).setCoinsText(this.value.toFixed(0));
                },
                delay: 0,
                duration: 2000,
            }),
        );

        yield* delay(2000);
    }

    public static createRewards(
        origin: Point,
        cropSpawnData: IHarvestSettings,
        textures: Random.IWeightedItem<string>[],
        delay?: number,
    ): HarvestCrop[] {
        const increment: number = (Math.PI * 2) / cropSpawnData.count;
        const rewards: HarvestCrop[] = [];

        for (let i = 0; i < cropSpawnData.count; i++) {
            const radius: number = cropSpawnData.radius * Random.value(0.125, 1);

            const offset: Point = new Point(
                cropSpawnData.originPoint.x + radius * Math.cos(increment * i),
                cropSpawnData.originPoint.y + radius * Math.sin(increment * i),
            );

            const newReward: HarvestCrop = GameObject.Instantiate(HarvestCrop, {
                texture: Random.getRandomWeighted(textures),
                cropPosition: Point.add(origin, offset),
                delay,
            });

            rewards.push(newReward);
        }

        return rewards;
    }
}
